import { render, staticRenderFns } from "./EditBusiness.vue?vue&type=template&id=78b3998b"
import script from "./EditBusiness.vue?vue&type=script&lang=js"
export * from "./EditBusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports